import React from 'react'
import { useNavigation } from '@react-navigation/core'
import { Container } from '../atoms'
import { TouchableOpacity } from 'react-native-web'
import { IconCloseCross, IconArrowBack } from '../../assets/icons'

export const BackButtonCross = ({ onPress }) => {
  const navigation = useNavigation()
  return (
    <Container
      center
      minimized
      style={{ width: 28, maxWidth: 28, marginLeft: 24, marginTop: 24 }}
    >
      <TouchableOpacity onPress={onPress || navigation.goBack}>
        <IconCloseCross height={20} width={20} />
      </TouchableOpacity>
    </Container>
  )
}

export const BackButtonArrow = ({ onPress, showModal }) => {
  const navigation = useNavigation()
  const onBack = () => {
    navigation.goBack()
    showModal && showModal()
  }
  return (
    <Container
      center
      minimized
      style={{ width: 28, maxWidth: 28, marginLeft: 24, marginTop: 24 }}
    >
      <TouchableOpacity onPress={onPress || onBack}>
        <IconArrowBack height={20} width={20} />
      </TouchableOpacity>
    </Container>
  )
}
